var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAgent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.4997 38.6967C66.4997 21.3117 53.0097 9.5 37.9997 9.5C23.148 9.5 9.49967 21.0583 9.49967 38.8867C7.59967 39.9633 6.33301 41.99 6.33301 44.3333V50.6667C6.33301 54.15 9.18301 57 12.6663 57H15.833V37.6833C15.833 25.4283 25.7447 15.5167 37.9997 15.5167C50.2547 15.5167 60.1663 25.4283 60.1663 37.6833V60.1667H34.833V66.5H60.1663C63.6497 66.5 66.4997 63.65 66.4997 60.1667V56.3033C68.368 55.3217 69.6663 53.39 69.6663 51.11V43.8267C69.6663 41.61 68.368 39.6783 66.4997 38.6967Z",
    fill: "#4FAE32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4997 44.3333C30.2486 44.3333 31.6663 42.9156 31.6663 41.1667C31.6663 39.4178 30.2486 38 28.4997 38C26.7508 38 25.333 39.4178 25.333 41.1667C25.333 42.9156 26.7508 44.3333 28.4997 44.3333Z",
    fill: "#4FAE32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4997 44.3333C49.2486 44.3333 50.6663 42.9156 50.6663 41.1667C50.6663 39.4178 49.2486 38 47.4997 38C45.7508 38 44.333 39.4178 44.333 41.1667C44.333 42.9156 45.7508 44.3333 47.4997 44.3333Z",
    fill: "#4FAE32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9995 34.9283C55.4795 25.9033 47.6262 19 38.1578 19C28.5628 19 18.2395 26.9483 19.0628 39.425C26.8845 36.2267 32.7745 29.26 34.4528 20.7733C38.6012 29.1017 47.1195 34.8333 56.9995 34.9283Z",
    fill: "#4FAE32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgent);
export default __webpack_public_path__ + "static/media/agent.b2da38538132f120369c5eb291e202eb.svg";
export { ForwardRef as ReactComponent };